/** Fixed Agile Syfan defaults overlaid onto `SuggestedLoad` before optional TMS search. */
import { Unit } from 'types/Load';

export const SHAREPOINT_PICKUP = {
  name: 'Agile',
  addressLine1: '3117 Athens HWY',
  city: 'Gainesville',
  state: 'GA',
  zipCode: '30501',
  country: 'US',
  timezone: 'America/New_York',
};

export const SHAREPOINT_CONSIGNEE = {
  name: 'PORT OF SAVANNAH- GCT',
  addressLine1: '2 Main St',
  city: 'GARDEN CITY',
  state: 'GA',
  zipCode: '31408',
  country: 'US',
  timezone: 'America/New_York',
};

export const SHAREPOINT_CUSTOMER = {
  name: 'AGILE COLD ATL NE, LLC',
  addressLine1: '300 NW 16TH ST.',
  addressLine2: '',
  city: 'Fruitland',
  state: 'ID',
  zipCode: '83619',
  country: 'US',
  contact: '',
  phone: '',
  email: '',
  refNumber: '',
};

/**
 * McLeod customer rate defaults for Agile SharePoint rows (matches typical built Agile dray loads).
 * Dollar rate/charge are fixed defaults; the sheet does not supply those cells.
 */
export const SHAREPOINT_AGILE_RATE_DEFAULTS = {
  collectionMethod: 'Prepaid',
  revenueCode: 'DRAYAGE 1',
  customerRateType: 'Flat',
  customerRateNumUnits: 1,
  /** Same dollar amount as charge; McLeod Rates `useEffect` derives charge from rate × units and clears charge if rate is empty. */
  customerLineHaulRate: 1286,
  customerLineHaulCharge: { val: 1286, unit: Unit.USD },
} as const;

/**
 * McLeod Specifications defaults for Agile SharePoint rows (Syfan tenant codes).
 * Export columns use display text (e.g. “40 FT CONTAINER”); the form stores transport option value `40C` and commodity code `FROZEN`.
 */
export const SHAREPOINT_AGILE_SPECIFICATIONS_DEFAULTS = {
  transportType: '40C',
  commodities: 'FROZEN',
} as const;
